import React from 'react';
import PropTypes from 'prop-types';
import getNavLink from './nav-links';
import NavbarDropdownHeader from './NavbarDropdownHeader';

const NavbarDropdownList = ({ label, children }) => (
  <li className="dropdown nav-item">
    <NavbarDropdownHeader id={label} link={getNavLink(label)}>{label}</NavbarDropdownHeader>
    <div
      tabIndex="-1"
      role="menu"
      left="true"
      aria-hidden="true"
      className="dark dropdown-menu"
    >
      {children}
    </div>
  </li>
);

NavbarDropdownList.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default NavbarDropdownList;
